import { Action, ActionSubject, type FeatureEvents, type ScreenEvent, type UIEvent } from '../new-analytics-types';

const unifiedGroupProfileScreen = 'unifiedGroupProfileScreen';

type ScreenKeys = 'unifiedGroupProfileScreen';
type UiKeys = keyof typeof uiEvents;

const uiEvents = {
  addUsersToGroupButtonClicked: ({ groupId }: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'addGroupMembers',
      source: unifiedGroupProfileScreen,
      attributes: {
        groupId,
      },
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/33862',
  }),
  grantAccessToGroupButtonClicked: ({ groupId }: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'openAddProductsModal',
      source: unifiedGroupProfileScreen,
      attributes: {
        groupId,
      },
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/40604',
  }),
  editGroupNameButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'editGroupName',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86678',
  }),
  editGroupDescriptionButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'editGroupDescriptionButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/13410',
  }),
  deleteGroupButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'deleteGroupButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/13412',
  }),
  connectNewTeamButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'createTeamButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/72406',
  }),
  connectExistingTeamButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'connectTeamButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/75737',
  }),
  disconnectTeamButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'disconnectTeamButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86618',
  }),
  deleteTeamButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'deleteTeamButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86619',
  }),
  viewTeamProfileButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Link,
      actionSubjectId: 'groupDetailsTeamLink',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/72418',
  }),
  editGroupAiAccessButtonClicked: (attributes: { groupId: string }): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'editGroupAiAccessButton',
      source: unifiedGroupProfileScreen,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/93376',
  }),
} as const;

export const unifiedGroupProfileEvents: FeatureEvents<ScreenKeys, UiKeys, never, never> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/5476530818/Analytics+Spec+Group+Profile+M1',
  screen: {
    unifiedGroupProfileScreen: ({
      groupId,
      memberCount,
      productAccessCount,
    }: {
      groupId: string;
      memberCount: number;
      productAccessCount: number;
    }): ScreenEvent => ({
      data: {
        name: unifiedGroupProfileScreen,
        attributes: {
          groupId,
          memberCount,
          productAccessCount,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86612',
    }),
  },
  ui: uiEvents,
  track: {},
  operational: {},
};
